import type { PaidBreakExceptionReason } from '#/shared/types/PaidBreakRequest';
import { getHourWord } from '#/shared/utils/dateTimeHelper';

import { PaidBreakExceptionDetails } from './PaidBreakExceptionDetails';

type PaidBreakExceptionErrorContentProps = {
  hours: string;
  reason?: PaidBreakExceptionReason;
  notes?: string;
  subtitle?: string | null;
};

export function PaidBreakExceptionErrorContent({
  hours,
  reason,
  notes,
  subtitle,
}: Readonly<PaidBreakExceptionErrorContentProps>) {
  const hourText = getHourWord(Number(hours));

  const defaultSubtitle =
    subtitle !== undefined ? subtitle : `If accepted, the timesheet will adjust to add ${hours} ordinary ${hourText}.`;

  return (
    <>
      {defaultSubtitle && <p className="text-base mb-8 text-on-surface-variant">{defaultSubtitle}</p>}
      <PaidBreakExceptionDetails reason={reason} notes={notes} />
    </>
  );
}
